import React from "react";
import { TicketsPage } from "../shared/TicketsPage";
export const SupportTicketsPage: React.FC = () => <TicketsPage />;
